import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseCollectionsResult } from '@hooks/dashboard/useCollections'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import OverviewMetricSectionCardContent from '../OverviewMetricSectionCardContent.component'

const INSURANCE_PATIENT_LEGEND = [
  { label: 'Insurance', color: 'var(--blue-400)' },
  { label: 'Patient', color: 'var(--orange-300)' },
] as const

function vsHighlight(actual: string, goal: string): React.ReactElement {
  return (
    <>
      {actual} <span className="dashboard-metric-value-vs">vs</span>{' '}
      <span className="dashboard-metric-value-over">{goal}</span>
    </>
  )
}

type OverviewCollectionCardProps = {
  titleHref: string
  collection: UseCollectionsResult
}

export function OverviewCollectionCard({
  titleHref,
  collection,
}: OverviewCollectionCardProps): React.ReactElement {
  const { topMetrics, highlight, chart, loading, hasData, hasPayload } =
    collection
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Collection"
      titleHref={titleHref}
      className="dashboard-collection-card dashboard-acceptance-card"
      loading={pending}
      skeleton={{ metrics: 4, block: 'chart' }}
      isEmpty={isEmpty}
      disableTitleLink={isEmpty}
    >
      <OverviewMetricSectionCardContent
        topMetrics={topMetrics}
        highlight={{
          leftLabel: highlight.leftLabel,
          value: vsHighlight(highlight.netActual, highlight.netGoal),
        }}
        chart={chart}
        legend={[...INSURANCE_PATIENT_LEGEND]}
      />
    </DashboardSectionCard>
  )
}
